import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Select, Table } from 'antd';
import util from '../../../util/index';
const {
  getParams,
} = util;
const FormItem = Form.Item;
const createForm = Form.create;
const Option = Select.Option;

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    formPrefixCls: 'sys-basic',
    conPrefixCls: 'sys-user',
    prefixCls: 'sys-app',
  }
  componentDidMount() {
    this.reset();
  }
  reset = () => {
    const { form, sysStore: { init, getAppBuy } } = this.props;
    form.resetFields();
    init();
    getAppBuy();
  }
  onSubmit = () => {
    const { sysStore: { init, getAppBuy }, form } = this.props;
    init(false);
    const params = getParams(form.getFieldsValue());
    getAppBuy(params);
  }
  edit = (tm_id, tm_status) => {
    const { sysStore: { editApp } } = this.props;
    editApp({ tm_id, tm_status }).then(() => {
      this.reset();
    })
  }
  getColumns = () => {
    const { conPrefixCls } = this.props;
    return [
      { title: '订单号', dataIndex: 'tm_oid', key: 'tm_oid', },
      { title: '应用名称', dataIndex: 's_name', key: 's_name', },
      { title: '应用编码', dataIndex: 's_number', key: 's_number', },
      { title: '申请人', dataIndex: 'm_name', key: 'm_name', },
      { title: '申请类型', dataIndex: 'tm_type', key: 'tm_type', },
      {
        title: '订单', dataIndex: 'tm_status', key: 'tm_status', render: (text) => {
          const title = text === '0' ? '驳回'
            : text === '1' ? '申请'
              : text === '2' ? '通过'
                : text === '5' ? '审核' : '';
          return (<div>{title}</div>);
        },
      },
      {
        title: '操作', dataIndex: 'op', key: 'op', render: (text, record) => {
          return (
            <div className={`${conPrefixCls}-joinList-btn`}>
              <span onClick={() => window.open(`${window.server}/web#/app/appDetail/${record.sw_id}`, '_blank')}>查看</span>
              <span onClick={() => this.edit(record.tm_id, 2)}>通过</span>
              <span onClick={() => this.edit(record.tm_id, 0)}>驳回</span>
            </div>
          )
        }
      },
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getAppBuy, setMobxState }, form } = this.props;
    setMobxState({ current, pageSize });
    const params = getParams(form.getFieldsValue());
    getAppBuy({ ...params, current, pageSize });
  }
  getExpandedRowRender = (record) => {
    return (
      <div>
        <div>申请人公司：{record.m_comname}</div>
        <div>申请人分部：{record.m_branch}</div>
        <div>申请人部门：{record.m_department}</div>
        <div>授权用户：{record.m_name}</div>
        <div>LICENSE：{record.m_license}</div>
      </div>
    )
  }
  render() {
    const { conPrefixCls, formPrefixCls, prefixCls, form, sysStore: { buyList, buyCount, loading, pageSize, current } } = this.props;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { getFieldProps } = form;
    return (
      <div className={`${formPrefixCls} ${conPrefixCls}`}>
        <div className={`${conPrefixCls}-header`}>
          <Form>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="订单号：" {...formItemLayout}>
                  <Input placeholder="请输入订单号" {...getFieldProps('tm_oid')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="应用名称：" {...formItemLayout}>
                  <Input placeholder="请输入应用名称" {...getFieldProps('s_name')} />
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="应用编码：" {...formItemLayout}>
                  <Input placeholder="请输入应用编码" {...getFieldProps('s_number')} />
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="申请类型：" {...formItemLayout}>
                  <Select {...getFieldProps('tm_type')}>
                    <Option value="0">试用</Option>
                    <Option value="1">永久</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="订单：" {...formItemLayout}>
                  <Select {...getFieldProps('tm_stauts')}>							
                    <Option value="0">驳回</Option>
                    <Option value="1">申请</Option>
                    <Option value="2">通过</Option>
                    <Option value="5">审核</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={8} className={`${formPrefixCls}-row`}>
                <FormItem label="申请人：" {...formItemLayout}>
    							<Input placeholder="请输入申请人" {...getFieldProps('m_name')} />
                </FormItem>
              </Col>
            </Row>
            <div className={`${formPrefixCls}-row ${prefixCls}-row-appApplyList-btn`}>
              <Button type="primary" onClick={this.onSubmit}>搜索</Button>
              <Button onClick={this.reset}>重置</Button>
            </div>
          </Form>
        </div>
        <Table
          rowKey="jl_id"
          loading={loading}
          dataSource={toJS(buyList)}
          columns={this.getColumns()}
          expandedRowRender={this.getExpandedRowRender}
          pagination={{
            total: buyCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/app/AppApplyList.js